<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="3">
          <v-date-picker elevation="2" class="rounded-lg" color="primary lighten-2" outlined width="100%" v-model.trim="myDate"></v-date-picker>
        </v-col>
        <v-col cols="12" sm="12" md="9">
          <v-card rounded="lg">
            <v-toolbar dense color="primary lighten-2" dark>
              <template v-slot:extension>
                <v-tabs v-model="tab">
                  <v-tabs-slider color=""></v-tabs-slider>
                  <v-tab>Student General Diary</v-tab>
                  <v-tab>Student Subject Diary</v-tab>
                </v-tabs>
              </template>
            </v-toolbar>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <span v-if="gnrlDiaryData.length > 0">
                  <v-card flat primary-title v-for="diary in gnrlDiaryData" :key="diary.id">
                    <v-card-title class="text-capitalize" v-text="diary.title"> </v-card-title>
                    <v-card-text> <v-card-subtitle v-html="diary.generalRemark"></v-card-subtitle></v-card-text>
                    <div class="ma-4" v-if="diary.studentGeneralDairyDocuments.length > 0">
                      <div class="body-2 mb-2">Attachments:</div>
                      <span class="tags d-inline-block mr-4" v-for="(file, i) in diary.studentGeneralDairyDocuments" :key="i">
                        <v-btn small elevation="1" class="caption" @click="getImg(file.urlPath)"> <v-icon left color="primary">mdi-download</v-icon> {{ file.filename }} </v-btn>
                      </span>
                    </div>

                    <v-divider></v-divider>
                    <v-card-actions class="px-4">
                      <span class="caption mr-6" v-text="`Section: ${diary.studentSection.name}`">Section</span>
                      <span class="caption" v-text="`Class: ${diary.studentClass.name}`"></span>
                      <v-spacer></v-spacer>
                      <span class="caption" v-text="diary.date"></span>
                    </v-card-actions>
                  </v-card>
                </span>
                <v-card v-else>
                  <v-card-subtitle class="error--text">No General Diary Is Maintained For This Date</v-card-subtitle>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <span v-if="sbjctDiaryData.length > 0">
                  <v-card flat primary-title v-for="sbjctDiary in sbjctDiaryData" :key="sbjctDiary.id">
                    <v-card-title class="text-capitalize">Class Work</v-card-title>
                    <v-card-text>
                      <v-card flat color="grey lighten-5">
                        <v-card-subtitle v-html="sbjctDiary.classWork"></v-card-subtitle>
                      </v-card>
                    </v-card-text>
                    <v-card-title class="text-capitalize">Home Work</v-card-title>
                    <v-card-text>
                      <v-card flat color="grey lighten-5">
                        <v-card-subtitle v-html="sbjctDiary.homeWork"></v-card-subtitle>
                      </v-card>
                    </v-card-text>
                    <v-card-title class="text-capitalize">Description</v-card-title>
                    <v-card-text>
                      <v-card flat color="grey lighten-5">
                        <v-card-subtitle v-html="sbjctDiary.description"></v-card-subtitle>
                      </v-card>
                    </v-card-text>
                    <div class="ma-4" v-if="sbjctDiary.studentSubjectDairyDocuments.length > 0">
                      <div class="body-2 mb-2">Attachments:</div>
                      <span class="tags d-inline-block mr-4" v-for="(file, i) in sbjctDiary.studentSubjectDairyDocuments" :key="i">
                        <v-btn small elevation="1" class="caption" @click="getImg(file.urlPath)"> <v-icon left color="primary">mdi-download</v-icon> {{ file.filename }} </v-btn>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-card-actions class="px-4">
                      <span class="caption mr-6" v-text="`Section: ${sbjctDiary.studentSection.name}`">Section</span>
                      <span class="caption" v-text="`Class: ${sbjctDiary.studentClass.name}`"></span>
                      <v-spacer></v-spacer>
                      <span class="caption" v-text="sbjctDiary.date"></span>
                    </v-card-actions>
                  </v-card>
                </span>
                <v-card v-else>
                  <v-card-subtitle class="error--text">No Subject Diary Is Maintained For This Date</v-card-subtitle>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: ['studentAdmissionId'],
  data () {
    return {
      academicYearID: '',
      franchiseeID: '',
      gnrlDiaryData: [],
      discriptionfile: [],
      myDate: null,
      student: null,
      tab: null,
      isLoading: false,
      sbjctDiaryData: []
    }
  },
  created: async function () {
    this.myDate = moment().format('YYYY-MM-DD')
    if (this.studentAdmissionId) {
      await this.studentData()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    student: async function () {
      await this.onFranchiseeChange()
    },
    myDate: async function () {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getImg: async function (path) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    getGeneralDiaryData: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/communication/studentGeneralDairy/user-type?academicYearID=${this.academicYearID}&franchiseeID=${this.franchiseeID}&date=${this.myDate}&classID=${this.student.classID}&sectionID=${this.student.sectionID}`
        )
        this.gnrlDiaryData = res.data
        this.gnrlDiaryData = this.gnrlDiaryData.map(a => {
          a.date = moment(a.date, 'YYYY-MM-DD').format('LL')
          a.studentGeneralDairyDocuments.map(b => {
            b.filename = b.urlKey.substring(b.urlKey.lastIndexOf('/') + 1)
          })
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getSubjectDiaryData: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/communication/studentSubjectDairy/user-type?academicYearID=${this.academicYearID}&franchiseeID=${this.franchiseeID}&date=${this.myDate}&classID=${this.student.classID}&sectionID=${this.student.sectionID}`
        )
        this.sbjctDiaryData = res.data
        this.sbjctDiaryData = this.sbjctDiaryData.map(a => {
          a.studentSubjectDairyDocuments.map(b => {
            b.filename = `${b.documentType} - ${b.urlKey.substring(b.urlKey.lastIndexOf('/') + 1)}`
          })
          a.date = moment(a.date, 'YYYY-MM-DD').format('LL')
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    studentData: async function () {
      try {
        this.isLoading = true
        let data = await http.get(`${constants.API_URL}/api/student/${this.studentAdmissionId}`)
        this.student = data.data
        this.student.studentEnrollment.dateOfBirth = moment(this.student.studentEnrollment.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.student.studentEnrollment.dateOfAdmission = moment(this.student.studentEnrollment.dateOfAdmission, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.student.studentEnrollment.gender =
          this.student.studentEnrollment.gender === 'MALE' ? 'Boy' : this.student.studentEnrollment.gender === 'FEMALE' ? 'Girl' : this.student.studentEnrollment.gender
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      if (this.franchiseeID && this.student) {
        await this.getGeneralDiaryData()
        await this.getSubjectDiaryData()
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
